import React from 'react';
import { motion } from 'framer-motion';
export function ForWhoSection() {
  return <section className="bg-gradient-hero py-20 md:py-28 px-4 md:px-8" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <div className="text-center mb-10 md:mb-14" data-id="element-85">
          <p className="uppercase tracking-[0.28em] text-[#C8A870] font-semibold mb-4 text-[13px]" data-id="element-86">
            El sistema completo
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-[#F0E8D8] leading-[1.1]" data-id="element-87">
            Qué recibís{' '}
            <span className="italic text-gradient-gold" data-id="element-88">al entrar</span>
          </h2>

          <div className="flex flex-wrap justify-center gap-2.5 mt-7 mb-7 text-sm" data-id="element-89"></div>

          <p className="mt-4 md:text-xl text-foreground/80 max-w-xl mx-auto text-[19px]" data-id="element-90">
            Todo lo que necesitás para empezar hoy, sin pensar ni improvisar.
          </p>
        </div>

        {/* Bundle mockup — premium showcase with generous breathing room */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative mt-12 md:mt-16 px-2 md:px-10" data-id="element-91">
          {/* Soft champagne halo behind the mockup */}
          <div className="absolute inset-0 -z-10 flex items-center justify-center pointer-events-none" data-id="element-92">
            <div className="w-[80%] h-[80%] rounded-full bg-gold/10 blur-[90px]" data-id="element-93" />
          </div>

          <div className="rounded-[4px] overflow-hidden border-[0.5px] border-gold/25 shadow-[0_0_60px_rgba(200,168,112,0.08),0_30px_60px_rgba(0,0,0,0.55)] bg-white/[0.02]" data-id="element-94">
            <img key="bundle-new" src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/blunde.png?v=1779840976" alt="Sistema completo H.E.R." loading="eager" className="w-full h-auto block" data-id="element-95" />
          </div>

          <p className="text-center mt-6 tracking-[0.18em] uppercase font-body text-[#C8A870] text-[14px]" data-id="element-96">
            Biblioteca digital H.E.R.
          </p>
        </motion.div>

        {/* List of items */}
        <motion.ul initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="mt-12 md:mt-16 space-y-6 max-w-xl mx-auto" data-id="element-97">
          {[{
          num: '01',
          title: 'Protocolo H.E.R. — Plan de 21 días',
          subtitle: 'Sabés exactamente qué hacer cada día. Sin improvisar.'
        }, {
          num: '02',
          title: 'Recetario H.E.R. — 63 recetas antiinflamatorias',
          subtitle: 'Comidas simples y reales, adaptadas a ingredientes argentinos y a esta etapa de tu vida.'
        }, {
          num: '03',
          title: 'H.E.R. Movement — 21 rutinas en casa',
          subtitle: 'Movete entre 15 y 25 minutos por día para sentirte mejor, sin gimnasio ni equipos costosos.'
        }, {
          num: '04',
          title: 'Guía de compras Argentina + Meal Prep',
          subtitle: 'Resolvé qué comprar y qué cocinar para las próximas 3 semanas en pocos minutos.'
        }, {
          num: '05',
          title: 'Tracker Premium H.E.R. — 21 días',
          subtitle: 'Registrá tus avances diarios y observá cómo cambian tu energía, descanso e inflamación.'
        }, {
          num: '06',
          title: 'Noche en Calma — 7 noches de ritual',
          subtitle: 'Un protocolo simple para reducir el estrés nocturno, mejorar el descanso y cortar el ciclo de antojos.'
        }].map((item, i) => <li key={i} className="flex items-start gap-4 text-left border-b-[0.5px] border-gold/10 pb-6 last:border-0" data-id="element-98">
              <span className="text-[13px] text-foreground/35 font-body font-medium flex-shrink-0 mt-0.5" data-id="element-99">
                {item.num}
              </span>
              <div data-id="element-100">
                <p className="font-display md:text-[18px] font-medium text-[#C8A870] text-[19px]" data-id="element-101">
                  {item.title}
                </p>
                <p className="font-body mt-1.5 text-[#F0E8D8] text-[17px]" data-id="element-102">
                  {item.subtitle}
                </p>
              </div>
            </li>)}
        </motion.ul>
      </div>
    </section>;
}